import { useEffect } from 'react';

interface KeyboardShortcutsProps {
  projectId: string | null;
  handleToggleSidebar: () => void;
  setAgentVisible: (visible: boolean) => void;
  setLogsVisible: (visible: boolean) => void;
  agentVisible: boolean;
  logsVisible: boolean;
}

export const useKeyboardShortcuts = ({
  projectId,
  handleToggleSidebar,
  setAgentVisible,
  setLogsVisible,
  agentVisible,
  logsVisible
}: KeyboardShortcutsProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'i') {
        e.preventDefault();
        if (projectId) {
          setAgentVisible(!agentVisible);
        }
      }
      
      if ((e.metaKey || e.ctrlKey) && e.key === 'b') {
        e.preventDefault();
        handleToggleSidebar();
      }
      
      if ((e.metaKey || e.ctrlKey) && e.key === 'j') {
        e.preventDefault();
        setLogsVisible(!logsVisible);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [projectId, handleToggleSidebar, setAgentVisible, setLogsVisible, agentVisible, logsVisible]);
}; 